<template>
    <div class="loader-ring">
        <div/>
        <div/>
        <div/>
        <div/>
    </div>
</template>

<style lang="scss">
    @import url("styles.scss");
</style>
